import { Component, OnInit, OnChanges, Input, Output, EventEmitter, SimpleChanges, AfterContentChecked, ElementRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ITableHeaders } from '@app/interface/table.interface';
import { TableConstant } from '@app/constant/table.constant';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'tableControl',
  templateUrl: './table-control.component.html',
  styleUrls: ['./table-control.component.scss']
})
export class TableControlComponent implements OnInit, OnChanges, AfterContentChecked {

  @ViewChild('stickyHeader') stickeyHeight: ElementRef;
  @ViewChild('scrollContainer') scrollVisibility: ElementRef;
  @ViewChild('popOver') public popover: NgbPopover;
  @Output() getTotalCount = new EventEmitter<any>();

  @Input() headerTheme: string = 'default';
  @Input() stickyHeader: boolean = true;
  @Input() isTableBorder: boolean = true;
  @Input() columnHeaders: ITableHeaders[];
  @Input() data: any[];
  @Input() tableAttributes?: any;
  @Input() paginationRequired: boolean = false;
  @Input() isMultiLine: boolean = false;
  @Input() groupView: boolean = false;
  @Input() pageingSize: number;
  @Input() rowCheckbox: string;
  @Input() radioButton: string;
  @Input() selectedCheckbox: any = [];
  @Input() disabledCheckbox: any = [];

  @Output() sortedChanged?= new EventEmitter();
  @Output() pageChanged?= new EventEmitter();
  @Output() navigateTo?= new EventEmitter();
  @Output() ActOnAction?= new EventEmitter();
  @Output() checkedItems?= new EventEmitter();
  @Output() rowActions?= new EventEmitter();
  @Output() rowSelected?= new EventEmitter();
  @Output() dialogName?= new EventEmitter();

  public onHvrTitleDesc = TableConstant.onHoverTitleDesc;
  stickyHeaderHeight: string = '0px';
  sortedColumn: string;
  sortedOrder: string;
  totalCount: number;
  pageVisibleRange: number = 5;
  pageNumberVisibleCount: number;
  pageSize: number;
  pageRange: any = [];
  selectedPage: number = 1;
  startPage: number = 1;
  endPage: number;
  selectedPageIndex: number;
  disableFirst: boolean = false;
  disableLast: boolean = false;
  isShow: Array<boolean> = [];
  expandedRow: number;
  groupedData: string;
  scrollActive: boolean = false;
  sortedData: any = [];
  openDropdown: boolean = false;
  filterValues: any = {};
  baseData: any[];
  selectedFilters: any = {};
  searchKey: string = "";
  tabb: string = "";
  notificationType: string;

  private _sharedService: any;
  constructor(private router: Router) { }

  ngOnInit() {
    this.sortedColumn = '';
    this.sortedOrder = '';
    this.selectedPageIndex = 1;
    this.disableFirst = true;
    this.sortedData = this.data?.slice();
  }

  public onClickHandler(clickedFilter) {
    this.selectedFilters[clickedFilter.srcElement.id] = clickedFilter.srcElement.checked;
  }

  public noFilters(): boolean {
    return Object.keys(this.selectedFilters).every((k) => !this.selectedFilters[k])
  }

  public filterColData() {
    if (this.noFilters()) {
      this.data = this.baseData
    } else {
      this.data = this.baseData;
      var i = 0;
      for (var key in this.filterValues) {
        var isCOlFilter = [];
        isCOlFilter = this.filterValues[key].filter(val => {
          if (val.isChecked) {
            return val;
          }
        });
        if (isCOlFilter.length) {
          this.data = this.data.filter(colVal => {
            if (this.selectedFilters[colVal[key].Value])
              return colVal;
          });
          this.getTotalCount.emit(this.data.length);
          this.columnHeaders?.forEach(each => {
            if (each.hasOwnProperty('filter') && each.filter === true) {
              var resArr = [];
              this.filterValues[each.DataField] = this.data.filter((colVal, index) => {
                var i = resArr.findIndex(x => x.name == colVal[each.DataField].Value);
                if (i <= -1) {
                  resArr.push({ name: colVal[each.DataField].Value });
                  return colVal[each.DataField].Value;
                }
              }).map(colVal => {
                let obj = {};
                if (each.DataField === "Cat") {
                  obj['name'] = colVal[each.DataField].Value;
                  obj['isChecked'] = this.selectedFilters[colVal[each.DataField].Value] === true ? true : false;
                  obj['desc'] = this.onHvrTitleDesc.Cat[colVal[each.DataField].Value];
                } else if (each.DataField === "Risk" || each.DataField === "Priority") {
                  obj['name'] = colVal[each.DataField].Value;
                  obj['isChecked'] = false;
                  obj['desc'] = this.onHvrTitleDesc[each.DataField][colVal[each.DataField].Value];
                }
                else {
                  obj['name'] = colVal[each.DataField].Value;
                  obj['isChecked'] = this.selectedFilters[colVal[each.DataField].Value] === true ? true : false;;
                }
                return obj;
              });
            }
          });
        }
      }
    }

    if (this.popover?.isOpen()) this.popover.close();
  }

  public resetFilter() {
    this.data = this.baseData
    this.getTotalCount.emit(this.data.length);
    this.columnHeaders?.forEach(each => {
      if (each.hasOwnProperty('filter') && each.filter === true) {
        var resArr = [];
        this.filterValues[each.DataField] = this.data.filter((colVal, index) => {
          var i = resArr.findIndex(x => x.name == colVal[each.DataField].Value);
          if (i <= -1) {
            resArr.push({ name: colVal[each.DataField].Value });
            return colVal[each.DataField].Value;
          }
        }).map(colVal => {
          this.selectedFilters[colVal[each.DataField].Value] = false;
          let obj = {};
          if (each.DataField === "Cat") {
            obj['name'] = colVal[each.DataField].Value;
            obj['isChecked'] = false;
            obj['desc'] = this.onHvrTitleDesc.Cat[colVal[each.DataField].Value];
          } else if (each.DataField === "Risk" || each.DataField === "Priority") {
            obj['name'] = colVal[each.DataField].Value;
            obj['isChecked'] = false;
            obj['desc'] = this.onHvrTitleDesc[each.DataField][colVal[each.DataField].Value];
          }
          else {
            obj['name'] = colVal[each.DataField].Value;
            obj['isChecked'] = false;;
          }
          return obj;
        });
      }
    });
  }
  filterResetColData() {
    if (this.noFilters()) {
      this.data = this.baseData
      this.getTotalCount.emit(this.data.length);
    } else {
      this.data = this.baseData;
      this.getTotalCount.emit(this.data.length);
      var i = 0
      for (var key in this.filterValues) {
        const isCOlFilter = this.filterValues[key].filter(val => {
          if (val.isChecked) {
            return val;
          }
        });
        if (isCOlFilter.length) {
          this.data = this.data.filter(colVal => {
            if (this.selectedFilters[colVal[key].Value])
              return colVal;
          });
          this.getTotalCount.emit(this.data.length);
        }
      }
    }
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (this.tableAttributes && this.tableAttributes.TotalCount > 0) {
      this.totalCount = this.tableAttributes.TotalCount;
      this.pageSize = this.pageingSize ? this.pageingSize : 10;
      this.endPage = this.totalCount > this.pageSize ? Math.ceil(this.totalCount / this.pageSize) : 1;
      this.pageNumberVisibleCount = this.pageVisibleRange;
      this.pageNumberVisibleCount = this.endPage > this.pageNumberVisibleCount ? this.pageNumberVisibleCount : this.endPage;
      this.handlePagination(this.tableAttributes.CurrentPage);
      this.LoadPageNumbers();
    }
    this.baseData = this.data;
    this.columnHeaders?.forEach(each => {
      if (each.hasOwnProperty('filter') && each.filter === true) {
        var resArr = [];
        this.filterValues[each.DataField] = this.data.filter((colVal, index) => {
          var i = resArr.findIndex(x => x.name == colVal[each.DataField].Value);
          if (i <= -1) {
            resArr.push({ name: colVal[each.DataField].Value });
            return colVal[each.DataField].Value;
          }
        }).map(colVal => {
          this.selectedFilters[colVal[each.DataField].Value] = false;
          let obj = {};
          if (each.DataField === "Cat") {
            obj['name'] = colVal[each.DataField].Value;
            obj['isChecked'] = false;
            obj['desc'] = this.onHvrTitleDesc.Cat[colVal[each.DataField].Value];
          } else if (each.DataField === "Risk" || each.DataField === "Priority") {
            obj['name'] = colVal[each.DataField].Value;
            obj['isChecked'] = false;
            obj['desc'] = this.onHvrTitleDesc[each.DataField][colVal[each.DataField].Value];
          }
          else {
            obj['name'] = colVal[each.DataField].Value;
            obj['isChecked'] = false;
          }
          return obj;
        });
      }
    });
  }

  public ngAfterContentChecked(): void {
    if (this.stickeyHeight && this.stickyHeader) {
      this.stickyHeaderHeight = '-' + this.stickeyHeight.nativeElement.offsetHeight + 'px';
    }
    if (this.scrollVisibility && this.stickyHeader) {
      this.scrollActive = this.scrollVisibility.nativeElement.offsetHeight < this.scrollVisibility.nativeElement.scrollHeight;
    }
  }

  showScrollTableOverlay() {
    return this.stickyHeader && Number.parseInt(this.stickyHeaderHeight) >= 0;
  }

  public searchDropdown(searchKey, colm) {
    this.filterValues[colm] = this.filterValues[colm].filter(function (item) {
      return item.name.indexOf(searchKey);
    });
  }

  private LoadPageNumbers() {
    if (this.pageNumberVisibleCount === 1) {
      this.pageRange = [];
      this.pageRange.push(1);
      this.disableFirst = true;
      this.disableLast = true;
      return;
    }

    if (this.selectedPage === this.pageRange[4]) {
      this.startPage = this.endPage - this.selectedPage < 4 ? this.endPage - 4 : this.selectedPage - 1;

    } else if (this.selectedPage === this.pageRange[0] && this.selectedPage > 3) {
      this.startPage = this.selectedPage - 3;

    } else if (this.selectedPage < 4) {
      this.startPage = 1;
    }

    this.pageRange = [];
    for (let i = this.startPage; i < this.pageNumberVisibleCount + this.startPage; i++) {
      this.pageRange.push(i);
    }
  }

  updatedSortColumn(orderBy, sortOrder) {
    this.sortedOrder = sortOrder === 'ASC' ? 'DESC' : 'ASC';
    this.sortedColumn = orderBy;
    const tableData = this.data.slice();

    if (!this.sortedColumn || this.sortedOrder === '') {
      this.sortedData = tableData;
    } else {
      this.sortedData = tableData.sort((a, b) => {
        const aValue = (a as any)[this.sortedColumn];
        const bValue = (b as any)[this.sortedColumn];
        return (aValue.Value < bValue.Value ? -1 : 1) * (this.sortedOrder === 'ASC' ? 1 : -1);
      });
    }
    this.sortedChanged.emit({
      sortColumn: this.sortedColumn,
      sortOrder: this.sortedOrder,
      currentPage: this.selectedPage,
      sortData: this.sortedData
    });
  }

  updatePage(selectedPage: any) {
    this.handlePagination(selectedPage);
    this.pageChanged.emit({
      sortColumn: this.sortedColumn,
      sortOrder: this.sortedOrder,
      currentPage: this.selectedPage
    });
  }

  public getMenuItems(items: any) {
    let res = [];
    for (var i = 0; i < items.length; i++) {
      res.push(items[i]);
    }
    return res;
  }
  public btnClick(rowData?: any, faultId?: number, title?: string, link?: string, type?: string, dialogName?: string) {
    if (type === 'openDialog') {
      this.dialogName.emit({ "dialogCondition": dialogName, "data": rowData })
    } else if (link.includes('dialog')) {
      this.dialogName.emit({ data: rowData });
    } else {
      let index = title === 'Add Comment' ? '2'
        : title === 'View Audit Trail' ? '4' 
          : '0';
      localStorage.setItem('tabIndex', index);
      const url = this.router.serializeUrl(this.router.createUrlTree([link + faultId]));
      window.open(url);
    }
  };

  private handlePagination(selectedPage: any) {
    if (this.disableFirst || this.disableLast) {
      this.disableFirst = false;
      this.disableLast = false;
    }
    switch (selectedPage) {
      case 'first':
        this.selectedPageIndex = 1;
        this.selectedPage = this.selectedPageIndex;
        this.startPage = 1;
        this.disableFirst = true;
        break;

      case 'previous':
        this.selectedPageIndex = this.selectedPage - 1;
        this.selectedPage = this.selectedPageIndex;
        this.disableFirst = this.selectedPage === 1;
        break;

      case 'next':
        this.selectedPageIndex = this.selectedPage + 1;
        this.selectedPage = this.selectedPageIndex;
        this.disableLast = this.selectedPage === this.endPage;
        break;

      case 'last':
        this.selectedPageIndex = this.endPage;
        this.selectedPage = this.selectedPageIndex;
        if (this.endPage > 4) {
          this.startPage = this.endPage - 4;
        }
        this.disableLast = true;
        break;

      default:
        this.selectedPageIndex = selectedPage;
        this.selectedPage = selectedPage;
        if (this.selectedPage === 1) {
          this.disableFirst = true;
        }
        if (this.selectedPage === this.endPage) {
          this.disableLast = true;
        }
        break;
    }

    if (
      this.pageRange.indexOf(this.selectedPage) === -1 &&
      this.selectedPage >= 1 &&
      this.selectedPage <= this.endPage - 4
    ) {
      this.startPage = this.selectedPage;
    }
  }
  asIsOrder() {
    return 1;
  }
  getTypeOf(value: any) {
    if (value !== undefined && value !== null) {
      return typeof value;
    }
    return null;
  }
  isProperURL(link) {
    return link && String(link).indexOf('http') > -1;
  }
  navigateToLink(evt, url: string, toNewTab=false) {
    evt.preventDefault();
    evt.stopPropagation();
    let origin = window.location.pathname.slice(window.location.pathname.lastIndexOf('/') + 1);
    const domain = `${window.location.origin}`;
    if (this.isProperURL(url)) {
      if (toNewTab) {
        localStorage.setItem('tabIndex', (origin === 'sdashboard') ? '5' : '0');
        window.open(url);
      } else {
        url = url.replace(domain, '');
        this.router.navigate([url.split('#')[0].split('?')[0]], {
          queryParams: this.router.parseUrl(url).queryParams,
          fragment: this.router.parseUrl(url).fragment
        });
      }
    } else {
      this.navigateTo.emit(url);
    }
  }
  actOnAction() {
    this.ActOnAction.emit();
  }
  toggleDisplay(id: number) {
    if (id !== undefined) {
      this.expandedRow = id;
      this.isShow[id] = this.isShow[id] === true ? false : true;
    }
  }
  chkBoxValue(chkRow) {
    this.checkedItems.emit(chkRow);
  }
  rowActionHandler(actionType, rowData) {
    this.rowActions.emit({ type: actionType, data: rowData });
  }
  selectRadioButton(selectedItem) {
    this.rowSelected.emit(selectedItem);
  }
}